<template>
	<div class="pb-5">
		<header-page
			:title="$route.meta.title"
		></header-page>
		<v-layout wrap px-5>
			<v-flex xs12>
				<v-layout  my-2 row align-center wrap class="optionSearch">
						<accounting-searcher
							class="searcher-accounting"
							:account="account.account"
							:account-name="account.name"
							@open-searcher="openSearcher"
						></accounting-searcher>
						<v-flex xs12 md2 pl-2 lg2>
							<BaseSelect
								item-text="name"
								item-value="id"
								:height="30"
								label="Fecha"
								:items="typesDate"
								@input="getDataDate($event)"
							/>
						</v-flex>
						<!-- <v-flex xs12 md2 pl-2 lg2>
							<BaseSelect
								item-text="description"
								item-value="id"
								:height="30"
								label="Plan Contable"
								:items="accountingPlan"
								:value="planAccountId"
								@input="getAccountingPlan($event)"
							/>
						</v-flex> -->
					<v-flex xs12 md2 pl-2  lg2 v-if="flagDate">
						<span class="captionDate">Fecha Desde</span>
						<date-component
							round
							:date="model.startDate"
							icon="/static/img/calendar.svg"
							@on-input="getDate({ model: 'startDate', value: $event })"
						></date-component>
					</v-flex>
					<v-flex xs12 md2 pl-2 lg2  v-if="flagDate">
						<span class="captionDate">Fecha hasta</span>
						<date-component
							round
							:date="model.endDate"
							icon="/static/img/calendar.svg"
							@on-input="getDate({ model: 'endDate', value: $event })"
						></date-component>
					</v-flex>
				</v-layout>
			</v-flex>
			<v-layout my-2 wrap row justify-end class="background-heading" >
				<v-col class="ml-1" cols="auto" align-center>
					<div class="content-blue font-weight-bold height-input px-2">
						<span class="debitV">DEBE: {{debit | formatAmount }}</span>
					</div>
				</v-col>
				<v-col class="ml-1" cols="auto" align-center>
					<div class="content-red font-weight-bold height-input px-2">
							<span class="debitC">HABER: {{credit | formatAmount }}</span>
					</div>
				</v-col>
				<v-col class="ml-1" cols="auto" align-center>
					<div class="content-gray font-weight-bold height-input px-2">
						<span class="debitB"> SALDO: {{amount | formatAmount }} </span>
					</div>
				</v-col>
			</v-layout>
			<v-flex xs12>
				<ledger-list
					:current-page="currentPage"
					:last-page="lastPage"
					:items-quantity="rows.length"
					:items-total-quantity="itemsTotalQuantity"
					:rows="rows"
					:number-seats="numberSeats"
					@on-search="onSearchData"
					@on-page="changePageDetails"
					@row-on-click="rowIsSelected"
					@on-click="rowIsSelected"
					@up-selected="upSelected($event, 'rows', 'rowIsSelected')"
					@down-selected="downSelected($event, 'rows', 'rowIsSelected')"
				></ledger-list>
			</v-flex>
		</v-layout>
		<general-filter class="layout background-grey py-3 px-2 my-3">
			<v-flex px-2>
				<label for="date" class="caption">Fecha</label>
				<baseInput
					:height="38"
					hide-details
					readonly
					:value="rowSelected.accountingSeat.date | exactDate"
				/>
			</v-flex>
			<v-flex px-2>
				<label for="date" class="caption">Asiento</label>
				<baseInput
					:height="38"
					hide-details
					readonly
					:value="rowSelected.accountingSeat.code"
				/>
			</v-flex>
			<v-flex px-2>
				<label for="date" class="caption">Referencia</label>
				<baseInput
					:height="38"
					hide-details
					readonly
					:value="detailSelected.reference"
				/>
			</v-flex>
			<v-flex px-2>
				<label for="date" class="caption">Módulo</label>
				<baseInput
					:height="38"
					hide-details
					readonly
					:value="detailSelected && detailSelected.module ? detailSelected.module.code : null"
				/>
			</v-flex>
			<v-flex px-2>
				<label for="date" class="caption">Descripción</label>
				<baseInput
					:height="38"
					hide-details
					readonly
					:value="rowSelected.accountingSeat.gloss"
				/>
			</v-flex>
			<v-flex px-2>
				<label for="date" class="caption">Concepto</label>
				<baseInput
					:height="38"
					hide-details
					readonly
					:value="rowSelected.concept"
				/>
			</v-flex>
		</general-filter>
		<v-layout wrap px-5>
			<v-flex xs12>
				<ledger-detail-list
					:rows="rowsDetails"
					@row-on-click="rowIsSelectedDetail"
					@up-selected="upSelected($event, 'rowsDetails', 'rowIsSelectedDetail')"
					@down-selected="downSelected($event, 'rowsDetails', 'rowIsSelectedDetail')"
				></ledger-detail-list>
				<journal-detail-balance
					:balance="balance"
					:credit="rowSelected.accountingSeat.totalHaber"
					:debit="rowSelected.accountingSeat.totalDebe"
				/>
			</v-flex>
		</v-layout>
		<action-sidebar
			:title="action.title"
			:value="action.value"
			:width="action.width"
			@close-modal="closeModal"
		>
			<slide-searcher
				v-if="isActionCode('searcher')"
				:columns="columns"
				:current-page="currentPageSearcher"
				:last-page="lastPageSearcher"
				:rows="records"
				:subsidiaries="subsidiaries"
				:subsidiary-id="subsidiaryId"
				text-btn="Seleccionar"
				@add-record="addRecord"
				@on-close="closeModal"
				@on-page="changePage"
				@on-search="onSearchRecords"
				@search-subsidiary="searchSubsidiary"
				@set-id="setId"
			/>
		</action-sidebar>
	</div>
</template>

<script>
	import { mapGetters } from 'vuex';
	import accountingSearcher from '@/components/shared/searcher/accounting-searcher';
	import actionSidebar from '@/components/shared/action-sidebar';
	import appDateSelect from '@/components/shared/app-date-select';
	import helper from '@/shared/helper';
	import journalDetailBalance from '@/components/journal/journal-detail-balance';
	import ledgerDetailList from '@/components/ledger/ledger-detail-list';
	import ledgerList from '@/components/ledger/ledger-list';
	import slideSearcher from '@/components/shared/searcher/slide-searcher';
	import baseInput from '@/components/shared/inputs/base-input';
	import { endOfMonth, format, subDays } from 'date-fns';
	import dateComponent from '@/components/autocomplete/date-component';

	const { debounce } = helper;

	function created() {
		if (this.currentSubsidiary) {
			this.newSubsidiaryId = this.currentSubsidiary.id;
		}
		const today = new Date();
		const firstDay = `${today.getFullYear()}-${today.getMonth()}-01`;
		this.model.startDate = format(firstDay, 'YYYY-MM-DD');
		this.model.endDate = this.$today;
		this.loadRecords();
		// this.loadAccounting();
	}
	function getDate({ value, model }) {
		if (model === 'startDate') {
			this.model[model] = format(value, 'YYYY-MM-DD');
			this.model.endDate = format(endOfMonth(value), 'YYYY-MM-DD');
		} else if (model === 'endDate') {
			this.model[model] = format(value, 'YYYY-MM-DD');
		}
		this.loadData();
	}

	function addRecord(record) {
		this.account = { ...record };
		localStorage.setItem('quipu::Acount', this.account.id);
		this.action.value = false;
		this.action.title = '';
		this.action.code = '';
		this.rows = [];
		this.rowsDetails = [];
		this.rowSelected = { accountingSeat: { totalDebe: 0, totalHaber: 0 } };
		this.detailSelected = {};
		this.loadData();
	}

	function changePage(page) {
		this.loadRecords(page);
	}
	function changePageDetails(page) {
		this.loadData(page);
	}

	function closeModal() {
		this.action.value = false;
		this.action.code = '';
		delete this.accountingParams.search;
	}

	function downSelected(row, type, typeSelected) {
		const index = this[type].findIndex(r => r.id === row.id);
		if (index > -1 && index < (this[type].length - 1)) {
			this[typeSelected](this[type][index + 1]);
		}
	}

	function isActionCode(code) {
		return this.action.code === code;
	}

	async function loadData(page = 1) {
		this.currentPage = page;
		this.params.page = this.currentPage;
		const startDate = this.model.startDate;
		const endDate = this.model.endDate;
		const params = this.params;

		try {
			const { data: response, headers } = await this.$http.get(
				`accounting-seat-details/${this.account.id}/${this.currentSubsidiary.id}?startDate=${startDate}&endDate=${endDate}`, { params });
			this.debit = Number(headers.totaldebe);
			this.credit = Number(headers.totalhaber);
			this.amount = Number(headers.totalbalance);
			this.numberSeats = Number(headers['x-quantity']);
			this.itemsTotalQuantity = Number(headers['x-quantity']);
			this.rows = response.map((row, index) => {
				const newRow = { ...row };
				newRow.isSelected = index === 0;
				return newRow;
			});
			this.rowsDetails = [];
			this.detailSelected = {};
			this.rowSelected = { accountingSeat: { totalDebe: 0, totalHaber: 0 } };
			this.rowIsSelected(this.rows.find(row => row.isSelected));
			this.lastPage = Number(headers['x-last-page']);
		} catch (err) {
			if (err.status === 500) {
				this.showGenericError();
			}
		}
	}

	async function loadRecords(page = 1) {
		this.currentPageSearcher = page;
		this.paramsRecords.page = this.currentPageSearcher;
		const subId = JSON.parse(localStorage.getItem('cs'));
		const params = { ...this.paramsRecords };
		// params.planAccountId = this.planAccountId ? this.planAccountId : 61;
		try {
			const { data: records, headers } = await this.$http.get(
				// `accounting-plan/${subId.id}/subsidiary?flag=false`, { params });
				`accounting-plan/${subId.id}/subsidiary?status=1`, { params });
			this.lastPageSearcher = Number(headers['x-last-page']);
			this.records = [...records];
			this.rowSelected();
		} catch (err) {
			if (err.status === 500) {
				this.showGenericError();
			}
		}
	}

	function onSearchData(search) {
		this.params.search = search.trim() ? search.trim() : null;
		this.loadData();
	}

	function onSearchDataDetail(search) {
		this.paramsDetail.search = search.trim() ? search.trim() : null;
	}

	function onSearchRecords(search) {
		this.paramsRecords.search = search.trim() ? search.trim() : null;
		this.loadRecords();
	}

	function openSearcher() {
		this.paramsRecords.search = null;
		if (this.newSubsidiaryId) {
			this.loadRecords();
		}
		this.action.title = 'Buscar Cuenta Contable';
		this.action.code = 'searcher';
		this.action.width = 550;
		this.action.value = true;
	}

	function rowIsSelected(row) {
		this.rows = this.rows.map((r) => {
			const newRow = { ...r };
			newRow.isSelected = row.id === r.id;
			return newRow;
		});
		this.rowSelected = row.id ? { ...row } :
			{ accountingSeat: {}, totalDebe: 0, totalHaber: 0 };
		this.rowsDetails = this.rowSelected.id ?
			this.rowSelected.accountingSeat.details.map((rowDetail, index) => {
				const newRowDetail = { ...rowDetail };
				newRowDetail.module = this.rowSelected.accountingSeat &&
					this.rowSelected.accountingSeat.typeRegister ?
					this.rowSelected.accountingSeat.typeRegister : null;
				newRowDetail.isSelected = index === 0;
				return newRowDetail;
			}) : [];
		this.rowIsSelectedDetail(this.rowsDetails[0]);
		this.onclick(row);
	}

	function onclick(row) {
		this.rows = this.rows.map((r) => {
			const newRow = { ...r };
			newRow.isSelected = row.id === r.id;
			return newRow;
		});
		this.rowSelected = row.id ? { ...row } :
			{ accountingSeat: {}, totalDebe: 0, totalHaber: 0 };
		this.rowsDetails = this.rowSelected.id ?
			this.rowSelected.accountingSeat.details.map((rowDetail, index) => {
				const newRowDetail = { ...rowDetail };
				newRowDetail.isSelected = index === 0;
				newRowDetail.module = this.rowSelected.accountingSeat &&
					this.rowSelected.accountingSeat.typeRegister ?
					this.rowSelected.accountingSeat.typeRegister : null;
				newRowDetail.isSelected = index === 0;
				return newRowDetail;
			}) : [];
		this.rowIsSelectedDetail(this.rowsDetails[0]);
	}

	function rowIsSelectedDetail(row) {
		this.rowsDetails = this.rowsDetails.map((detail) => {
			const newDetail = { ...detail };
			newDetail.isSelected = row.id === detail.id;
			return newDetail;
		});
		this.detailSelected = row.id ? { ...row } : {};
	}

	function rowSelectedWatcher(value) {
		const debt = Number(value.accountingSeat.totalDebe) || null;
		const credit = Number(value.accountingSeat.totalHaber) || null;
		this.balance = debt - credit;
	}

	async function searchSubsidiary(value, detail) {
		const params = detail ? null : { search: value };
		const url = detail ? `subsidiary/${value}/detail` : 'subsidiary';
		try {
			const { data: response } = await this.$http.get(url, { params });
			this.subsidiaries = detail ? [{ ...response }] : [...response];
			if (detail) {
				this.setId({ id: this.subsidiaries[0].id });
			}
		} catch (err) {
			if (err.status === 500) {
				this.showGenericError();
			} else if (err.status === 400) {
				this.showGenericError(err.data.message);
			}
		}
	}
	async function subsidiaryChange(newSubsidiary) {
		this.loadRecords(1, newSubsidiary);
	}
	function setId() {
		this.loadRecords();
	}

	function getDataDate(val) {
		if (val === 1) {
			this.model.startDate = this.$today;
			this.model.endDate = this.$today;
			this.flagDate = false;
		} else if (val === 2) {
			this.model.startDate = format(subDays(this.$today, 1), 'YYYY-MM-DD');
			this.model.endDate = format(subDays(this.$today, 1), 'YYYY-MM-DD');
			this.flagDate = false;
		} else if (val === 3) {
			this.model.startDate = format(subDays(this.$today, 7), 'YYYY-MM-DD');
			this.model.endDate = this.$today;
			this.flagDate = false;
		} else if (val === 4) {
			const today = new Date(this.$today);
			const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
			this.model.startDate = firstDayOfMonth.toISOString().split('T')[0];
			this.model.endDate = this.$today;
			this.flagDate = false;
		} else if (val === 5) {
			const today = new Date(this.$today);
			// Set the startDate to the first day of the current year
			const firstDayOfYear = new Date(today.getFullYear(), 0, 1);
			this.model.startDate = firstDayOfYear.toISOString().split('T')[0];
			this.model.endDate = this.$today;
			this.flagDate = false;
		} else if (val === 6) {
			this.model.startDate = format(subDays(this.$today, 7), 'YYYY-MM-DD');
			this.model.endDate = this.$today;
			this.flagDate = true;
		}
		this.loadData();
	}

	function upSelected(row, type, typeSelected) {
		const index = this[type].findIndex(r => r.id === row.id);
		if (index > 0) {
			this[typeSelected](this[type][index - 1]);
		}
	}

	// async function loadAccounting() {
	// 	try {
	// 		const { data: response } = await this.$http.get('com-accounting-plan');
	// 		this.accountingPlan = response;
	// 	} catch (error) {
	// 		this.showGenericError();
	// 	}
	// }

	// function getAccountingPlan(accountId) {
	// 	this.planAccountId = accountId;
	// 	this.loadRecords();
	// }

	function data() {
		return {
			account: {},
			model: {
				endDate: 0,
				startDate: 0,
			},
			accountingParams: {
				limit: 20,
				page: 1,
				status: 1,
			},
			action: {
				code: '',
				title: 'Buscar Cuenta Contable',
				value: false,
				width: 500,
			},
			balance: 0,
			columns: [
				{
					id: 1,
					name: 'Nombre',
					value: 'name',
					checked: true,
					visible: true,
				},
				{
					id: 2,
					name: 'Cuenta',
					value: 'account',
					checked: true,
					visible: true,
				},
				{
					id: 3,
					name: 'Acción',
					checked: true,
					visible: true,
					flagVisible: true,
				},
			],
			currentPage: 1,
			currentPageSearcher: 1,
			detailsSelected: [],
			detailSelected: {
				accountingAccount: {},
				module: {},
			},
			lastPage: 0,
			flagDate: false,
			lastPageSearcher: 0,
			params: {
				limit: 10,
				page: 1,
			},
			paramsRecords: {
				limit: 30,
				page: 1,
			},
			records: [],
			typesDate: [
				{ id: 1, name: 'Hoy' },
				{ id: 2, name: 'Ayer' },
				{ id: 3, name: 'Ultima Semana' },
				{ id: 4, name: 'Mes Actual' },
				{ id: 5, name: 'Año Actual' },
				{ id: 6, name: 'Rangos de Fechas' },
			],
			rows: [],
			rowsDetails: [],
			rowSelected: {
				accountingSeat: {
					totalDebe: 0,
					totalHaber: 0,
				},
			},
			subsidiaries: [],
			debit: 0,
			credit: 0,
			amount: 0,
			newSubsidiaryId: null,
			total: null,
			numberSeats: null,
			itemsTotalQuantity: null,
			// accountingPlan: [],
			// planAccountId: 61,
		};
	}

	export default {
		name: 'page-ledger',
		computed: {
			...mapGetters('subsidiary', [
				'currentSubsidiary',
			]),
		},
		components: {
			accountingSearcher,
			actionSidebar,
			journalDetailBalance,
			ledgerDetailList,
			ledgerList,
			slideSearcher,
			baseInput,
			dateComponent,
			appDateSelect,
			BaseSelect: () => import('@/components/shared/inputs/base-select'),
		},
		created,
		data,
		methods: {
			addRecord,
			changePage,
			onclick,
			closeModal,
			downSelected,
			isActionCode,
			loadData,
			loadRecords,
			onSearchData,
			onSearchDataDetail,
			onSearchRecords,
			openSearcher,
			getDataDate,
			rowIsSelected,
			rowIsSelectedDetail,
			searchSubsidiary: debounce(searchSubsidiary),
			setId,
			upSelected,
			getDate,
			changePageDetails,
			// loadAccounting,
			// getAccountingPlan,
		},
		props: {
			subsidiaryId: [Number, String],
		},
		watch: {
			rowSelected: {
				deep: true,
				handler: rowSelectedWatcher,
			},
			currentSubsidiary: subsidiaryChange,
		},
	};
</script>

<style lang="scss" scoped>
	.background-grey {
		background-color: PowderBlue !important;
	}
	.captionDate {
		font-size: 10px;
    text-align: center;
		font-family: 'AvenirRegular';
	}
	.btn-action {
		top: 68px;
		position: absolute;
		width: 100px !important;
	}
	.content-blue {
		opacity:0.8;
		background-color: #02979b ;
		border-radius: 10px;
		height: 31px;
		@media (max-width: 768px) {
			font-size: 11px;
			width: 194px;
		}
		.debitV {
			width: 174px;
			height: 20px;
			font-family: 'AvenirRegular';
			font-size: 14px;
			font-weight: bold;
			font-stretch: normal;
			font-style: normal;
			line-height: 1.54;
			letter-spacing: normal;
			text-align: center;
			color: white;
		}
	}

	.content-gray {
		background-color: #77a1d1;
		border-radius: 10px;
		color: map-get($colors, white);
		height: 31px;
		@media (max-width: 768px) {
			font-size: 11px;
			width: 194px;
		}
		.debitB {
			width: 174px;
			height: 20px;
			font-family: 'AvenirRegular';
			font-size: 14px;
			font-weight: bold;
			font-stretch: normal;
			font-style: normal;
			line-height: 1.54;
			letter-spacing: normal;
			text-align: center;
			color: white;
		}
	}
	.content-red {
		opacity: 0.8;
		background-color: color(secondary);
		border-radius: 10px;
		height: 31px;
		@media (max-width: 768px) {
			font-size: 11px;
			width: 194px;
		}
	.debitC {
			width: 174px;
			height: 20px;
			font-family: 'AvenirRegular';
			font-size: 14px;
			font-weight: bold;
			font-stretch: normal;
			font-style: normal;
			line-height: 1.54;
			letter-spacing: normal;
			text-align: center;
			color: white;
		}
	}
	.background-heading {
		@media (max-width: 768px) {
			@include flex-center;
			max-width: 1200px;
			margin: 0 auto;
			display: grid;
			align-items: center;
			gap: 0.2rem;
		}
	}
	.optionSearch {
		@media (max-width: 768px) {
			@include flex-center;
			max-width: 1200px;
			margin: 0 auto;
			display: grid;
		}
	}
</style>



// WEBPACK FOOTER //
// src/pages/journal/page-ledger.vue